/**
 * paper-3-xlsx — 지면 파이프라인 ③ 그리기의 두 번째 매체: xlsx.
 *   html 은 paper-3-html 이 그리지만, xlsx 는 그리는 손이 백엔드다
 *   (hcltech-parts quote/xlsx-onepage.ts — ExcelJS 새 워크북에 칸을 그대로 옮긴다).
 *   프론트 몫은 채워진 지면을 고객 지면(CustomerPaper)으로 넘기는 것뿐.
 *
 * ── 계약 = CustomerPaper ──
 *   백엔드는 칸에서 r·c·rs·cs·s·t 여섯 개만 읽는다(zod: cols·rows·styles·cells). 스타일 11필드는 CellStyle 과 동일.
 *   채워진 지면(InPaper)에서 역할 도장만 벗기면 고객 지면이다 — 칸의 주소(r·c)까지 그대로 서버로 간다.
 *
 * ── xlsx 는 언제나 고객 종이 ──
 *   현재 뷰가 무엇이든 고객 뷰로 채워 넘긴다(View onExportXlsx). 우리 칸이 섞였으면 여기서 즉사.
 */
import { assert } from '../../lib/assert';
import type { InPaper, CustomerPaper, TemplateCell } from './paper-0-cells';

/**
 * 채워진 지면 → 고객 지면. 역할 도장(kind·idx·field·input·look·sourceIdx)을 벗긴다 —
 * 고객 문서 요청에 편집기 살림을 실어 보내지 않기 위해. 값(t)·자리(r·c)·서식 번호(s)는 그대로.
 */
export function toCustomerPaper(inPaper: InPaper): CustomerPaper {
  assert(inPaper.cells.every((cell) => cell.kind !== 'our-line'),
    'xlsx 는 고객 종이 — 우리 칸(our-line)이 섞여 있다. 고객 뷰로 채운 지면을 넘겨야 한다');

  const cells = inPaper.cells.map((cell): TemplateCell => ({
    r: cell.r, c: cell.c, rs: cell.rs, cs: cell.cs, s: cell.s,
    ...(cell.t != null ? { t: cell.t } : {}),
  }));
  return { cols: inPaper.cols, rows: inPaper.rows, styles: inPaper.styles, cells };
}
